import React from 'react';
import { ConstCss } from '../../const/Const';
import { ReactComponent as ExcelIcon } from '../../svg/excelIcon.svg'

const IconExcel = () => {
    return (
        <div style={{ ...ConstCss.flexCenter, cursor: 'pointer' }}>
            <ExcelIcon />
        </div>
    );
}

export default IconExcel;